var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C12.9 6 12 6.9 12 8V36C12 37.1 12.9 37.9999 14 37.9999H34C35.1 37.9999 36 37.1 36 36V14L28 6H14Z",
    fill: "#E6EBF5",
    fillOpacity: 0.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30 14H36L28 6V12C28 13.1 28.9 14 30 14Z",
    fill: "#BBC1C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36 20L30 14H36V20Z",
    fill: "#BBC1C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32C32 32.55 31.55 33 31 33H9C8.45 33 8 32.55 8 32V22C8 21.45 8.45 21 9 21H31C31.55 21 32 21.45 32 22V32Z",
    fill: "#BBC1C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31 33H12V34H31C31.55 34 32 33.55 32 33V32C32 32.55 31.55 33 31 33Z",
    fill: "#BBC1C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.387 30V29.16L17.139 25.32H14.475V24.48H18.259V25.32L15.499 29.16H18.339V30H14.387ZM19.3396 30V24.48H20.3556V30H19.3396ZM25.6837 26.288C25.6837 26.8373 25.5317 27.2667 25.2277 27.576C24.9237 27.8853 24.4491 28.04 23.8037 28.04H22.6837V30H21.6677V24.48H23.8037C24.4437 24.48 24.9157 24.6427 25.2197 24.968C25.5291 25.288 25.6837 25.728 25.6837 26.288ZM24.6197 26.112C24.6197 25.5947 24.3157 25.336 23.7077 25.336H22.6837V27.184H23.7077C24.3157 27.184 24.6197 26.9333 24.6197 26.432V26.112Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipIcon);
export default __webpack_public_path__ + "static/media/zip-icon.b44b5ed87b2c87bb35dbe41ab2f3b67e.svg";
export { ForwardRef as ReactComponent };